// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CardSpendingInsightsViewHomeEvent
 */
export var CardSpendingInsightsViewHome = function () { return ({
    name: "CardSpendingInsights View Home",
    parameters: {
        cdf_entity: "CardSpendingInsights",
        cdf_action: "View",
    }
}); };
/**
 * @see CardSpendingInsightsViewInsightEvent
 */
export var CardSpendingInsightsViewInsight = function (_a) {
    var type = _a.type;
    return ({
        name: "CardSpendingInsights View Insight",
        parameters: {
            cdf_entity: "CardSpendingInsights",
            cdf_action: "View",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CardSpendingInsightsViewAllActivityEvent
 */
export var CardSpendingInsightsViewAllActivity = function () { return ({
    name: "CardSpendingInsights View AllActivity",
    parameters: {
        cdf_entity: "CardSpendingInsights",
        cdf_action: "View",
    }
}); };
/**
 * @see CardSpendingInsightsViewBenefitsEvent
 */
export var CardSpendingInsightsViewBenefits = function () { return ({
    name: "CardSpendingInsights View Benefits",
    parameters: {
        cdf_entity: "CardSpendingInsights",
        cdf_action: "View",
    }
}); };
